import { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import BaseModel from 'volta/models/base-model';
import type { IResourceName } from 'volta/models/base-model';

export const PartTypeResourceName: IResourceName = {
  singular: 'partType',
  plural: 'partTypes'
};

export default class PartType extends BaseModel {
  @attr('string') code!: string;
  @attr('string') description?: string;
  @attr('string') externalId?: string;
  @attr('boolean', { defaultValue: false }) isDefault!: boolean;

  get partTypeId() {
    return this.id;
  }

  get isOperation(): boolean {
    return this.code === 'OPERATION';
  }

  [Type] = 'part-type' as const;
}
